import React from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../contexts/LanguageContext';

export const Hero = () => {
  const { t } = useLanguage();
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center pt-40 pb-32">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-slate-900"></div>
        <img 
          src="https://customer-assets.emergentagent.com/job_gearbox-shop/artifacts/rf72qpag_1000159554.jpg"
          alt="ESBLY AUTO Logo"
          className="absolute inset-0 w-full h-full object-contain opacity-10"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/70 via-slate-900/60 to-slate-900/70"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-red-600/20 border border-red-500/30 rounded-full px-4 py-2 mb-6">
            <CheckCircle size={18} className="text-red-400" />
            <span className="text-red-300 text-sm font-medium">{t.hero.badge}</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-8 leading-tight">
            {t.hero.title1}
            <span className="block text-red-500 mt-2">{t.hero.title2}</span>
          </h1>

          {/* Description */}
          <p className="text-xl sm:text-2xl text-slate-300 mb-10 leading-relaxed max-w-2xl">
            {t.hero.description}
          </p>

          {/* Key Points */}
          <div className="grid sm:grid-cols-3 gap-4 mb-10">
            <div className="flex items-center gap-2">
              <CheckCircle size={20} className="text-red-400 flex-shrink-0" />
              <span className="text-slate-200">{t.hero.experience}</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle size={20} className="text-red-400 flex-shrink-0" />
              <span className="text-slate-200">{t.hero.warranty}</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle size={20} className="text-red-400 flex-shrink-0" />
              <span className="text-slate-200">{t.hero.service}</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              onClick={() => scrollToSection('contact')}
              size="lg"
              className="bg-red-600 hover:bg-red-700 text-white text-lg px-8 py-6 transition-all hover:scale-105"
            >
              {t.hero.cta1}
              <ArrowRight className="ml-2" size={20} />
            </Button>
            <Button 
              onClick={() => scrollToSection('services')}
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-slate-900 text-lg px-8 py-6 transition-all"
            >
              {t.hero.cta2}
            </Button>
          </div>

          {/* Bosch Service Partner Badge */}
          <div className="mt-10 pt-10 border-t border-slate-600">
            <p className="text-slate-300 text-sm mb-4">Partenaire Agréé</p>
            <img 
              src="https://customer-assets.emergentagent.com/job_gearbox-shop/artifacts/ahto3vcq_1000159553.jpg"
              alt="Bosch Service"
              className="h-16 w-auto"
            />
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce hidden sm:block">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};
